import type {TrackingStatus} from '../types';
import {URL_PARAMS} from '@/constants';

export const ORDERS_URL_PARAMS = {
  ...URL_PARAMS,
  CUSTOMER_NUMBER: 'customer_number',
  PO_NUMBER: 'po_number',
  EAN: 'ean',
  ISBN: 'isbn',
  ORDER_DATE: 'order_date',
  SEARCH: 'q',
  SELECTED_PO_NUMBER: 'selected_po_number',
  SHIPPING_STATUS: 'shipping_status',
  PO_STATUS: 'po_status',
  EXPORT_XLS: 'export_xls',
} as const;

export const ORDERS_FROZEN_COLUMNS = ['order_date', 'po_number'];

export const NOT_HIDABLE_COLUMNS = ['order_date', 'po_number'];

export const ORDERS_COLUMN_STYLES = {
  order_date: {width: 150},
  po_number: {width: 150},
  invoice_numbers: {width: 170},
  shipped_units: {width: 150},
  on_pick_units: {width: 150},
  backorder_units: {width: 150},
  canceled_units: {width: 150},
  credit_hold_units: {width: 150},
  number_of_titles: {width: 150},
};

export const ORDERS_DETAILS_FROZEN_COLUMNS = ['order_date'];
export const ORDERS_DETAILS_NOT_HIDABLE_COLUMNS = ['order_date'];

export const ORDERS_DETAILS_COLUMN_STYLES = {
  order_date: {width: 150},
  tracking_date: {width: 150},
  status: {width: 150},
  isbn: {width: 150},
  ean: {width: 150},
  title: {width: 200},
  author: {width: 200},
  imprint: {width: 150},
  format: {width: 150},
  title_status: {width: 150},
  shipped_units: {width: 150},
  on_pick_units: {width: 150},
  backorder_units: {width: 150},
  credit_hold_units: {width: 150},
  canceled_units: {width: 150},
  pro_number: {width: 150},
  carrier_description: {width: 200},
};

export const ORDERS_DETAILS_URL_PARAMS_PREFIX = 'order_details';

export const ORDERS_DETAILS_URL_PARAMS = {
  LIMIT: `${ORDERS_DETAILS_URL_PARAMS_PREFIX}_${ORDERS_URL_PARAMS.LIMIT}`,
  OFFSET: `${ORDERS_DETAILS_URL_PARAMS_PREFIX}_${ORDERS_URL_PARAMS.OFFSET}`,
  SHIPPING_STATUS: `${ORDERS_DETAILS_URL_PARAMS_PREFIX}_${ORDERS_URL_PARAMS.SHIPPING_STATUS}`,
  PO_STATUS: `${ORDERS_DETAILS_URL_PARAMS_PREFIX}_${ORDERS_URL_PARAMS.PO_STATUS}`,
  SEARCH: `${ORDERS_DETAILS_URL_PARAMS_PREFIX}_${ORDERS_URL_PARAMS.SEARCH}`,
  SELECTED_PO_NUMBER: `${ORDERS_DETAILS_URL_PARAMS_PREFIX}_${ORDERS_URL_PARAMS.SELECTED_PO_NUMBER}`,
  ORDER_DATE: `${ORDERS_DETAILS_URL_PARAMS_PREFIX}_${ORDERS_URL_PARAMS.ORDER_DATE}`,
  FILTERS: `${ORDERS_DETAILS_URL_PARAMS_PREFIX}_filtersValues`,
  EXPORT_XLS: `${ORDERS_DETAILS_URL_PARAMS_PREFIX}_${ORDERS_URL_PARAMS.EXPORT_XLS}`,
} as const;

export const ACCORDION_CONTENTS_KEYS = {
  DETAILS: 'DETAILS',
  TRACKING: 'TRACKING',
};

export const ORDER_SHIPPING_STATUS_COLORS = {
  Delivered: 'delivered',
  Shipped: 'shipped',
  'Not Shipped': 'not-shipped',
};

export const FALLBACK_VALUE = '—';

export const TRACKING_STATUSES = {
  CANCELED: 'canceled',
  CREATED: 'created',
  DELIVERED: 'delivered',
  ERROR: 'error',
  IN_TRANSIT: 'in_transit',
  UNKNOWN: 'unknown',
} as const;

export const TRACKING_STATUS_COLORS: Partial<Record<TrackingStatus, string>> = {
  [TRACKING_STATUSES.CREATED]: 'not-shipped',
  [TRACKING_STATUSES.DELIVERED]: 'delivered',
  [TRACKING_STATUSES.ERROR]: 'error',
  [TRACKING_STATUSES.IN_TRANSIT]: 'shipped',
};
